export default {
    "title_en": "Title English",
    "title_ar": "Title Arabic",
    "Logout" : "Logout",
    "lang" : "عربي",
    "Create" : "Create",
    "Delete" : "Delete",
    "Title En" : "English Title",
    "Title Ar" : "Arabic Title",
    "title english" : "English Title",
    "title arabic" : "Arabic Title",
    "AssetItem": "Equipment",
    "AssetItemCategory":"Equipment Category",
    "AssetItem Ecri": "Equipment Identification",
    "Equipment Identification": "Equipment Identification",
    "EquipmentType":"Equipment Type",
    "AssetItem Utility": "Equipment Utility",
    "AssetItem Group": "Equipment Group",
    "AssetItem Type": "Equipment Type",
    "AssetItem UOM": "Equipment UOM",
    "AssetItem Risk Class": "Risk Class",
    "AssetItemCategoryOption": "Equipment Category Option",
    "AssetItemGroupOption":"Equipment Group Option",
    "Supplier Manufacturer": "Supplier / Manufacturer",
    "SupplierManufacturerStatus":"Supplier Manufacturer Status",
    "CustomerStatus":"Customer Status",
    "Assign Asset Item":"Assign Equipment",
    "CoverageType":"Coverage / Type",
    "MeasuringPeriod":"Measuring Period",
    "PenaltyUOM":"Penalty UOM",
    "PenaltyUom":"Penalty UOM",
    "LaborManagement":"Labor Management",
    "ProjectStage":"Project Stage",
    "projectStage":"Project Stage",
    "ProjectStatus":"Project Status",
    "projectStatus":"Project Status",
    "RoomSpace":"Room Space",
    "RoomSpaceCategory":"Room Space Category",
    "roomSpaceCategory":"Room space Category",
    "RoomSpaceItem":"Equipment",
    "Allocate Asset / Item":"Equipment",
    "SparePartManagement":"Spare Part Management",
    "AssignTicket":"Assign Ticket",
    "Ticket":"Ticket / Request",
    "TicketStatus":"Ticket Status",
    "WorkOrder":"Work Order",
    "WorkOrderFailureType":"Failure Type",
    "WorkOrderStatus":"Work Order Status",
    "WorkOrderType":"Work Order Type",
    "WorkOrderCategory":"Work Order Category",
    "PlanPreventiveMaintenance":"Plan Preventive Maintenance",
    "Name en":"Name in english",
    "Name ar":"Name in arabic",
    "MedicalUse":"Medical Use ?",
    "AssetDetails":"Equipment Details",
    "CommonName":"Equipment Identification",
    "commonName":"Equipment Identification",
    "SerialNumber":"Serial Number",
    "serialNumber":"SerialNumber",
    "BatchNo.":"Batch No.",
    "LOTNO.":"LOT NO.",
    "TechnicalDetails":"Technical Details",
    "RiskClass":"Risk Class",
    "IntendedUse":"Intended Use",
    "ShelfLife":"Shelf Life",
    "CutSheet":"Cut Sheet",
    "Issparepart":"Is spare part ?",
    "OptionTitleEn":"Option Title in english",
    "OptionTitleinenglish":"Option Title in english",
    "OptionTitleAr":"Option Title in arabic",
    "ecriName":"Name",
    "ecriCode":"Code",
    "Asset/ItemCategory":"Equipment Category",
    "Embedlocation":"Embed location",
    "FacilityFloor":"Facility Floor",
    "facilityBuilding":"Department/Medical Center",
    "facilityRoom":"facility Room",
    "facilityDepartment":"facility Department",
    "facilityRoomRef.":"facility Room Ref.",
    "CustomerSLA":"Customer SLA",
    "customerSLA":"Customer SLA",
    "GeneralDetails":"General Details",
    "AssetName":"Equipment Identification",
    "SoftwareVersion":"Software Version",
    "ManufacturingDate":"Manufacturing Date",
    "PurchaseOrder":"Purchase Order",
    "PODate":"Purchase Order Date",
    "POReference":"Purchase Order Reference",
    "POValue":"Purchase Order Value",
    "DocumentParent":"Document Group",
    "ChildCategory":"Document Group Type",
    "OptionKey":"Option Key",
    "OptionValue":"Option Value",
    "assign_asset_item":"Assign Equipment",
    "contract_value":"contract value",
    "coverage_type": "Coverage Type",
    "response_time":"Response time",
    "repair_time":"Repair time",
    "measuring_period":"measuring period",
    "from_date":"from date",
    "to_date":"to date",
    "penalty_rate":"Penalty Rate",
    "penalty_uom":"penalty UOM",
    "import_grace_period":"Import Grace Period",
    "purchase_requisition_ref":"purchase requisition ref",
    "supplier_quotation_ref":"supplier quotation ref",
    "purchase_order_ref":"purchase order ref",
    "asset_code":"Equipment code",
    "penalty_uom_id":"Penalty UOM",
    "est_cost":"Est cost",
    "actual_cost":"Actual cost",
    "projectPhase":"Project Phase",
    "ProjectDetails":"Project Details",
    "ProjectName":"Project Name",
    "ProjectVersion":"Project Version",
    "ProjectReference":"Project Reference",
    "RoomSpaceName":"Room Space Name",
    "RoomSpaceRef":"RoomSpace Ref",
    "RoomQuantity":"Room Quantity",
    "roomQuantity":"Room Quantity",
    "Manufacturer_part_no":"Manufacturer part number",
    "manufacturer_part_no":"Manufacturer part number",
    "wo_reference":"work order reference",
    "created_date":"created date",
    "start_date":"start date",
    "finish_date":"finish date",
    "closed_date":"closed date",
    "Closed_date":"closed date",
    "Requested_by":"Requested by",
    "assigned_to":"Assigned To",
    "failure_type":"failure type",
    "Requester_signing_off":"Requester signing off",
    "Contract_id":"Contract",
    "priority_id":"Priority",
    "Customer Category":"Customer Category",
    "Customer Status":"Customer Status",
    "Assign Asset / Item Status":"Assign Equipment Status",
    "ProjectPhase":"Project Phase",
    "Project Stage":"Stage",
    "Project Status":"Project Status",
    "Room Space Category":"Room Space Category",
    "Room Space Item":"Room Space Item",
    "Work Order Failure Type":"Work Order Failure Type",
    "Work Order Status":"Work Order Status",
    "Work Order Type":"Work Order Type",
    "Work Order Category":"Work Order Category",
    "Customer status":"Customer status",
    "customer Status":"customer Status",
    "RoomsSpaces":"Room Spaces",
    "RoomSpace Name":"RoomSpace Name",
    "AssignAssetItem":"Assign Equipment",
    "AssetLocation":"Equipment Location",
    "assignAssetItem":"Assign Equipment",
    "measuringPeriod":"Measuring Period",
    "roomSpaceRef":"Room Space Ref",
    "created_by":"created by",
    "requested_by":"Requested by",
    "request_description":"request description",
    "closed_by":"closed by",
    "requester_signing_off":"requester signing off",
    "contract_id":"contract",
    "failureType":"failure Type",
    "PMFrequency":"PM Frequency",
    "QAFrequency":"QA Frequency",
    "CalibrationFrequency":"Calibration Frequency",
    "InstallationDate":"Installation Date",
    "InServiceDate":"In Service Date",
    "ExpireDate":"Expire Date",
    "Welcome to AEON ":"Welcome to AEON",
    "AssetItem View":"Equipment View",
    "Customer View":"Customer View",
    "isMedicalUse":"Is Medical Use ?",
    "isSparePart":"Is Spare Part ?",
    "SupplierManufacturer":"Supplier / Manufacturer",
    "Additional":"Configuration",
    "Role":"User Group",
    "AssetItemRiskClass":"Equipment Risk Class",
    "CreateAssetItem":"Create Equipment",
    "Asset/ItemMasterData":"Equipment Master Data",
    "Asset/ItemStatus":"Equipment Status ",
    "Supplier/Manufacturer":"Supplier / Manufacture",
    "WarrantyStartDate":"Warranty Start Date",
    "WarrantyEndDate":"Warranty End Date",
    "Asset/ItemRef.":"Equipment Ref.",
    "TechnicalDetials":"Technical Detials",
    "Intendeduse":"Intended use",
    "Asset/ItemCommonName":"Code",
    "ECRIName":"Name",
    "SupplierStatus":"Supplier Status",
    "SupplierRanking":"Supplier Ranking",
    "DepreciationRate":"Depreciation Rate",
    "PMType":"PM Type",
    "Asset/ItemName":"Equipment Identification",
    "PurchaseOrderDate":"Purchase Order Date",
    "Asset/ItemGroup":"Equipment Group",
    "Procurement/Installation":"Procurement / Installation",
    "DownloadDocument":"Download Document",
    "ItemReference":"Item Reference",
    "LOTNo.":"LOTNo.",
    "Asset/ItemRef.Generation":"Equipment Ref. Generation",
    "TitleorImage":"Title or Image",
    "Reset":"Reset",
    "CustomerName":"Customer Name",
    "CustomerCategory":"Customer Category",
    "SiteName":"Site",
    "SiteBuilding":"Site Building",
    "SiteDepartment":"Site Department",
    "SiteRoom":"Site Room",
    "SiteWarehouse":"Site Warehouse",
    "TicketType":"Ticket Type",
    "TicketSubType":"Ticket Sub Type",
    "FromDate":"From Date",
    "ToDate":"To Date",
    "toDate":"To Date",
    "Contract_ref":"Contract Ref",
    "intendeduse":"Intended use",
    "ContractType":"Contract Type",
    "PlanPreventiveMaintenanceType":"Plan Preventive Maintenance Type",
    "AssetItemUtilityInput":"Equipment Utility Input",
    "AssetItemDocumentationGroup":"Document Group",
    "AssetItemDocumentationGroupType":"Document Type",
    "DocumentationGroup":"Document Group",
    "DocumentationGroupType":"Document Type",
    "AssignAssetItemStatus":"Equipment Status",
    "PODateFrom":"PO Date From",
    "PODateTo":"PO Date To",
    "InstallationDateFrom":"Installation Date From",
    "InstallationDateTo":"Installation Date To",
    "AssignAsset/ItemRef.":"Assign Equipment Ref.",
    "SubCustomer":"Sub Customer",
    "StartDateFrom":"Start Date From",
    "StartDateTo":"Start Date To",
    "AlternativeAsset/ItemRef. ":"Alternative Equipment Ref. ",
    "EcriName":"Name",
    "EcriCode":"Code",
    "AlternativeAsset/ItemRef.":"Alternative Equipment Ref.",
    "TicketCategory":"Ticket Category",
    "TicketSub-Category":"Ticket Sub-Category",
    "ConvertedtoWO":"Converted to WO",
    "AllocateAsset/ItemRef.":"Allocate Equipment Ref.",
    "WOCategory":"WO Category",
    "WOType":"WO Type",
    "WOStatus":"WO Status",
    "WODateFrom":"WO Date From",
    "WODateTo":"WO Date To",
    "Assignedto":"Assigned To",
    "RequestedBy":"Requested By",
    "ClosedBy":"Closed By",
    "CreatedBy":"Created By",
    "FailureType":"Failure Type",
    "created_on":"Created on",
    "AllocateAsset/Item":"Equipment",
    "StartDate":"Start Date",
    "EndDate":"End Date",
    "ContractRef.":"Contract Ref.",
    "coverageType":"Coverage Type",
    "InventoryTaking":"Inventory Taking",
    "TypicalSpace":"Typical Space",
    "SpaceRef.":"Space Ref.",
    "Asset/Items":"Equipments",
    "Assets/Items":"Equipments",
    "WorkOrderCost":"WorkOrder Cost",
    "WorkOrderAttachment":"WorkOrder Attachment",
    "WorkOrderStatusHistory":"WorkOrder Status History",
    "WorkOrderActionOption":"WorkOrder Action Option",
    "WorkOrderAction":"WorkOrder Action",
    "PeriodName":"Period Name",
    "Preview Attachment":"Preview Attachment",
    "Report problem":"Report problem",
    "Facility":"Site",
    "Facilities":"Site",
    "ControlNo.":"Control No.",
    "EquipmentName":"Equipment identification",
    "SerialNo.":"Serial No.",
    "ModelNo.":"Model No.",
    "SubCategory":"Sub Category",
    "WarrantyPeriod(Y)":"Warranty Period(Y)",
    "facilities":"Site",
    "Subcontract":"Sub Contract",
    "EquipmentData":"Equipment Data",
    "EquipmentAllocation":"Equipment Allocation",
    "SparePart":"Spare Part",
    "MedicalCenters":"Medical Centers",
    "SupervisorDelegate":"Supervisor Delegate",
    "PrimarySupervisor":"Primary Supervisor",
    "InReport":"In Report ",
    "IsPrimaryActive?":"Is Primary Active ?",
    "ResponseTime/Day":"Response Time / Day",
    "PaymentTerms":"Payment Terms",
    "VisitValue":"Visit Value",
    "CallCenterContact":"Call Center Contact",
    "CallCenterEmail":"Call Center Email",
    "All the pending Work Orders":"All the pending Work Orders",
    "LastPPM":"Last PPM",
    "NextPPM":"Next PPM",
    "PPMWO":"PPM WO",
    "CorrectiveWO":"Corrective WO",
     "Addanewattachments":"Add a new attachment",
    "AllPendingStatus":"All Pending Status",
    'code':'Code',
    'assigned':'Assigned',
    'delegate':'Delegate',
    'name':'Name',
    "assigned to":"Assigned To",
    "fail date":"Fail Date",
    "ContactName":"Contact Name",
    "Technican":"Technician",
    "quantity":"Quantity",
    "status":"Status",
    "TechnicanDelegate":"Technician Delegate",
    "PrimaryTechnican":"Primary Technician",
    "thisfieldisrequiredwhenwarrantystatusisyes":"this field is required when warranty status is yes",
    "ECRI":"Equipment identification",
    "Mapurl":"Map url",
    "Abstracts":"Abstracts",
    "AutogeneratePPM":"Auto generate PPM",
    "AutomaticallyGeneratePlanPreventiveMaintenanceforequipmentofthedepartmentbythesystem":"Automatically Generate Plan Preventive Maintenance for equipment of the department by the system",
    "Chooseanoption":"Choose an option",
    "thisfieldisrequiredwhenprimaryinactive":"this field is required when primary is inactive",
    "Mapurl":"Map url",
    "at row number": "At row number",
    "CreateWorkorder": "Create Work order",
    "ActivityLog": "Activity Log",
    "type": "Type",
    "category": "Category",
    "planpreventive": "Plan Preventive",
    "master_no": "Master No",
    "rank": "Rank",
    "mpn": "MPN",
    "ticket": "Ticket",
    "description": "Description",
    "Controlnumber": "Control Number",
    "priority": "Priority",
    "Assignto": "Assign To",
    "WorkOrderDetails": "Work Order Details",
    "Maintenance department supervisor": "Maintenance Department Supervisor",
    "Abstract types":"Abstract types",
    "Yes":"Yes",
    "No":"No",
    "Ecri name":"Name",
    "ECRI Name":"Name",
    "ActivityLogPerUser":"Activity Log Per User",
    "Shipment received from the Health Authority": "Shipment received from the Health Authority",
    "Operation": "Operation",
    "Creation date": "Creation date",
    "Last activity by": "Last activity by",
    "shipping representative": "shipping representative",
    "Order status log": "Order status log",
    "Assigned parties": "Assigned parties",
    "Waste details": "Waste details",
    "DHL Express Company": "DHL Express Company",
    "Shipping company": "Shipping company",
    "Health Authority - Hospital": "Health Authority - Hospital",
    "Address details": "Address details",
    "Al Jazirah - Corniche Road, Jeddah": "Al Jazirah - Corniche Road, Jeddah",
    "Contact number": "Contact number",
    "Email": "Email",
    "View details": "View details",
    "Hide details": "Hide details",
    "The process has not started yet": "The process has not started yet",
    "On the way to the health authority": "On the way to the health authority",
    "DHL Express": "DHL Express",
    "Create an ad group": "Create an ad group",
    "Create an ad": "Create an ad",
    "Waste Managment": "Waste Managment",
    "Mohammad Hesham, ": "Mohammad Hesham,",
    "Name of toxic medical waste": "Name of toxic medical waste",
    "Waste category": "Waste category",
    "Number of waste": "Number of waste",
    "Action": "Action",
    "Toxic waste": "Toxic waste",
    "Drugs": "Drugs",
    "kg": "kg",
    "The shipment was received from the Health Authority": "The shipment was received from the Health Authority",
    "The shipment was approved from the Health Authority": "The shipment was approved from the Health Authority",
    "The waste was delivered for treatment": "The waste was delivered for treatment",
    "The received shipment has been approved": "The received shipment has been approved",
    'responsible_side':"The responsible party",
    "Waste Management":"Waste Management",
    "waste_num":"Total number of wastes",
    "created_at":"Created at",

    "NotStarted":"Not Started",
    "Onthewaytothehealthauthority":"On the way to the health authority",
    "Shipmenthasbeenreceivedfromthehealthauthority":"Shipment has been received from the health authority",
    "Theshipmenthasbeenapprovedbythehealthauthority":"The shipment has been approved by the health authority",
    "Thewastehasbeendeliveredforprocessing":"The waste has been delivered for processing",
    "representative":"Shipping representative",
    "TicketLabel":"Ticket Label",
    "TicketLabels":"Ticket Labels",
    "multipletags":"Multiple Tags",
    "PrimarySecurity":"Primary Security",
    "SecurityDelegate":"Security Delegate",
    "IsSecurityPrimaryActive?":"Is Security Primary Active?",
    "PrimarySafety":"Primary Safety",
    "SafetyDelegate":"Safety Delegate",
    "IsSafetyPrimaryActive?":"Is Safety Primary Active?",
    "PrimaryMainHelpDesk":"Primary Main Help Desk",
    "MainHelpDeskDelegate":"Main Help Desk Delegate",
    "IsMainHelpDeskPrimaryActive?":"Is Main Help Desk Primary Active?",
    "PrimaryDepartmentHelpDesk":"Primary Department Help Desk",
    "DepartmentHelpDeskDelegate":"Department Help Desk Delegate",
    "IsPrimaryDepartmentHelpDeskActive?":"Is Primary Department Help Desk Active?",
    "AssignDepartmentHelpDesk":"Assign Department Help Desk",
    "Processingcompany":"Processing Company",
    'Site':'Site',
    'OK':'OK',
    "You cannot {{variable}} this item because it has related:":"You cannot {{variable}} this item because it has related:",
    "Site Type":'Site Type',
    "Site Info":'Site Info',
    "NoSparePartsYet":"No Spare Parts Yet",
    "NoAttachmentsYet":"No Attachments Yet",
    "mailalreadysent,checkyourinbox!":"mail already sent, check your inbox!",
    "ThankYou!":"Thank You !",
    "Recordsuccessfullyupdated":"Record successfully updated",
    "Return":"Return",
    "AddanewAttachments":"Add a new attachment",
    "AddaSparePart":"Add a Spare Part",
    "ExistingSparePart":"Existing Spare Part ",
     "Re-openingcomments":"Opening Comments",
     "Addacomment":"Add a Comment",
     "Comment":"Comment",
     "Recordsuccessfullycreated":"Record successfully Created",
      "withidNo":", with id No. #",    
      "Pleaseenteravalidemailaddress":"Please enter a valid email address",
      "Related WO":"Related WO",
      "Closereason":"Close Reason",
    "SelectOptions":"Select Options",
    "Pleaseselecttheroom":"Please select the room",
    "Plan Preventive Maintenance":"Plan Preventive Maintenance",
    "created":"created",
    "updated":"updated",    
    "Old":"Old",
    "Attribute":"Attribute",
    "facility_id":"facility namber",
    "assigned_id":"assigned namber",
    "delegate_id":"delegate namber",
    "is_primary_active":"is primary active",
    "department_equipment_auto_ppm":"department equipment auto ppm",
    "assigned_department_help_desk_id":"assigned department help desk number",
"delegate_department_help_desk_id":"delegate department help desk number",
"is_primary_active_help_desk":"is primary active help desk",
"notified":"notified",
"building_id":"building number",
"department_id":"department namber",

"sla_start_time":"sla start time",
"pm_date":"pm date",
"plan_preventive_maintenance_id":"plan preventive maintenance number",
"ticket_sub_type_id":"ticket sub type number",
"room_item_id":"room item number",
"room_id":"room number",
"project_id":"project number",
"service_id":"service number",
"category_id":"category number",
"status_id":"status number",
"assigned_to_user":"assigned to user",
"assigned_to_user.name":"assigned to user name",
"status_data.title_ar":"status title ar",
"secondary_status_data.title_en":"secondary status title en",
"status_data":"status date",
"secondary_status_id":" secondary status number",
"secondary_status_data.title_ar":"secondary status title ar",
"status_data.title_en":"status title en",
"room_space_item_id":"room space item number",
"end_date":"end date",
"create_wo":"create wo",
"supplier_id":"supplier number",
"currency_id":" currency number",
"coverage_type_id":"coverage type number",
"measuring_period_id":" measuring period number",
"contract_ref":"contract ref",
"payment_terms_id":"payment terms number",
"contract_type_id":"contract type number",
"is_medical_use":"is medical use",
  "ecri_type":"Ecri Type",
"type_id":"Type Id",
"group_id":" Group Id",
"ecri_code":"Ecri Code",
"ecri_name":"Ecri Name",
"ArabicContractorName":"Arabic Contractor Name",
"EnglishContractorName":"English Contractor Name",
"PpmCreateat":"PPM Create at",
"TicketCreateat":"Ticket Create at",
"SlaStatus":"SLA Status",
"Staff":localStorage.getItem('staffLabelEn'),


}
